import React, { useEffect } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { FaUser, FaPhone, FaEnvelope, FaBuilding, FaMapMarkerAlt, FaPenAlt } from 'react-icons/fa'
import { useDispatch, useSelector } from "react-redux"

import {
    memberToForm,
    onChange,
    onChangeByName,
    submitInformation,
    userToForm
} from "../../redux/registration/registrationAction"
import CountriesInput from "../../components/form/countriesInput"
import PhoneInput from "../../components/form/phoneInput"
import ProfessionalInput from "../../components/form/professionalInput"
import HelpUr from "../../components/help/help"
import AlertCategory from "./alertCategory/alertCategory"
import { isDefined } from "../../utils/data"

const About = ({ prevTab, nextTab }) => {
    const dispatch = useDispatch()
    const { information } = useSelector(({ registrationReducer }) => registrationReducer)
    const { categories, category, user, member } = useSelector(({ apiReducer }) => apiReducer)
    const localCategories = ["Plein tarif", "Membre d'une association partenaire, jeune médecin", "Jeune médecin adhérent (AJPJA, AESP, AJG), chercheur, retraité, interne", "	Interne adhérent à l'AFFEP"]

    const disabledInput = isDefined(user)

    var txt_accueil = "";
    var txt_accueil2 = "";
    var titre_accueil = "";
    var baseline = "";

    useEffect(() => {
        if (user !== null) {
            dispatch(userToForm(user))

            if (localCategories.filter(ctg => ctg !== "Other").indexOf(user.registered.profession_category) === -1) {
                dispatch(onChangeByName("registered_profession_category", user.registered.profession_category))
                dispatch(onChangeByName("professionalCtgSelect", "Other"))
            }
            else {
                dispatch(onChangeByName("registered_profession_category", user.registered.profession_category))
            }
        }
    }, [user])

    useEffect(() => {
        if (member !== null) {
            dispatch(memberToForm(member))
        }
    }, [member])

    if (user) {
        var titre_accueil = "Bienvenue sur votre espace personnel";
        var txt_accueil = "<small>Vous pouvez modifier ci-dessous vos informations de contact.<br />Pour regler votre inscription ou télécharger votre facture, rendez-vous sur le dernier onglet.";
    } else if (information.unionMember) {
        var baseline = "<span style='color:#ef787c'><b>Sur place et/ou à distance</b></span>";
        if (information.unionMember.value == "CFP_medecin" || information.unionMember.value == "CFP_para") {
            var titre_accueil = "Inscription au Congrès Français de Psychatrie 2022";
            var txt_accueil = "<small>Droits d'inscription incluant l'accès <span style='color:#ef787c'><b>sur place et/ou à distance</b></span> à l'ensemble du congrès y compris le Forum des Associations, les Journées de Psychiatrie de la Personne Âgée, la Journée Sciences Infirmières et Recherche Paramédicale, la Journée de l'ACCompagnement et de l'action médico-sociale et la Journée du Comité Local d'Organisation</small>";
        } else if (information.unionMember.value == "JSIRP") {
            var titre_accueil = "Journée Sciences Infirmières et Recherche Paramédicale";
            var txt_accueil = "<small>Droit incluant l’accès <span style='color:#ef787c'><b>sur place et/ou à distance</b></span> à la 5<sup>e</sup> Journée Sciences Infirmières et Recherche Paramédicale mercredi 30 novembre 2022</small>";
        } else if (information.unionMember.value == "JACC") {
            var titre_accueil = "Journée de l'ACCompagnement et de l'action médico-sociale (JACC)";
            var txt_accueil = "<small>Droit incluant l’accès <span style='color:#ef787c'><b>sur place et/ou à distance</b></span> à la 5<sup>e</sup> Journée de l'ACCompagnement et de l'action médico-sociale (JACC) mercredi 30 novembre 2022</small>";
        } else if (information.unionMember.value == "JPPA") {
            var titre_accueil = "Journées de Psychiatrie de la Personne Âgée (JPPA)";
            var txt_accueil = "<small>Droit incluant l’accès <span style='color:#ef787c'><b>sur place et/ou à distance</b></span> aux 7<sup>e</sup> Journées de Psychiatrie de la Personne Âgée (JPPA). Sous l'égide de la Société Francophone de Psychogériatrie et de Psychiatrie de la Personne Âgée. Vendredi 2 et samedi 3 décembre 2022</small>";
        }
    } else {
        var txt_accueil = "Merci de bien vouloir choisir votre évènement en cliquant ci-dessous";
        var txt_accueil2 = "<a class='sr-btn-next btn btn-sm btn-secondary' href='https://cfp2022.urevent.fr'>Accueil</a>";
    }


    const onSubmit = (e = null) => {
        e.preventDefault()
        const form = e.currentTarget
        // form.myButton.disabled = true;
        // form.myButton.value = "En cours...";

        if (form.checkValidity() === false) {
            form.myButton.disabled = false;
            form.myButton.value = "Suivant";
            e.stopPropagation()
        }

        dispatch(submitInformation(user, information, categories, category, nextTab))
    }

    if (user !== null || information.unionMember) {
        return (
            <div className={"content about"}>
                <p className={"title"} dangerouslySetInnerHTML={{ __html: titre_accueil }}></p>
                <p className={"important-infos"} dangerouslySetInnerHTML={{ __html: txt_accueil }}></p>
                {
                    txt_accueil != "" ?
                    <>
                    <p className={"important-infos"} dangerouslySetInnerHTML={{ __html: txt_accueil2 }}></p>
                    </>
                    :
                    ""
                }               

                <form onSubmit={onSubmit} className={"needs-validation"} noValidate>
                    <div className="form-group">
                        <div className="form-row">
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaUser /></label>
                                <select className="form-control" name={"registered_gender"} value={information.registered_gender.value} onChange={e => dispatch(onChange(e))} required>
                                    <option value="" disabled selected>Titre *</option>
                                    <option>Dr</option>
                                    <option>Prof</option>
                                    <option>M.</option>
                                    <option>Mme</option>
                                    <option>Mlle</option>
                                </select>
                                {information.registered_gender.error !== "" ?
                                    <div className="invalid-feedback">{information.registered_gender.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaBuilding /></label>
                                <select className="form-control" name={"registered_function"} value={information.registered_function.value} onChange={e => dispatch(onChange(e))} required>
                                    <option value="" disabled selected>Mode d'exercice *</option>
                                    <option>Hospitalier</option>
                                    <option>Libéral</option>
                                    <option>Mixte</option>
                                    <option>Autre</option>
                                </select>
                                {information.registered_function.error !== "" ?
                                    <div className="invalid-feedback">{information.registered_function.error}</div>
                                    : ""}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaUser /></label>

                                <input type="text" className="form-control" placeholder="Prénom *" name={"registered_firstname"} value={information.registered_firstname.value} onChange={e => dispatch(onChange(e))} disabled={disabledInput} required />
                                {information.registered_firstname.error !== "" ?
                                    <div className="invalid-feedback">{information.registered_firstname.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaUser /></label>
                                <input type="text" className="form-control" placeholder="Nom *" name={"registered_lastname"} value={information.registered_lastname.value} onChange={e => dispatch(onChange(e))} disabled={disabledInput} required />
                                {information.registered_lastname.error !== "" ?
                                    <div className="invalid-feedback">{information.registered_lastname.error}</div>
                                    : ""}
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="form-row">
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaMapMarkerAlt /></label>
                                <input type="text" className="form-control" placeholder="Adresse *" name={"registered_adress1"} value={information.registered_adress1.value} onChange={e => dispatch(onChange(e))} required />
                                {information.registered_adress1.error !== "" ?
                                    <div className="invalid-tooltip">{information.registered_adress1.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaMapMarkerAlt /></label>
                                <input type="text" className="form-control" placeholder="Adresse comp." name={"registered_adress2"} value={information.registered_adress2.value} onChange={e => dispatch(onChange(e))} required={information.registered_adress2.required} />
                                {information.registered_adress2.error !== "" ?
                                    <div className="invalid-tooltip">{information.registered_adress2.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-4 col-lg-4 input-group"}>
                                <label><FaMapMarkerAlt /></label>
                                <input type="text" className="form-control" placeholder="Code Postal*" name={"registered_zipcode"} value={information.registered_zipcode.value} onChange={e => dispatch(onChange(e))} required />
                                {information.registered_zipcode.error !== "" ?
                                    <div className="invalid-tooltip">{information.registered_zipcode.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-4 col-lg-4 input-group"}>
                                <label><FaMapMarkerAlt /></label>
                                <input type="text" className="form-control" placeholder="Ville *" name={"registered_city"} value={information.registered_city.value} onChange={e => dispatch(onChange(e))} required />
                                {information.registered_city.error !== "" ?
                                    <div className="invalid-tooltip">{information.registered_city.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-4 input-group"}>
                                <label><FaMapMarkerAlt /></label>
                                <CountriesInput value={information.registered_country.value} onChange={e => dispatch(onChange(e))} />
                                {information.registered_country.error !== "" ?
                                    <div className="invalid-tooltip">{information.registered_country.error}</div>
                                    : ""}
                            </div>

                        </div>
                    </div>

                    <div className="form-group">
                        <div className="form-row">
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaEnvelope /></label>
                                <input type="email" className="form-control" placeholder="Email *" name={"registered_mail"} value={information.registered_mail.value} onChange={e => dispatch(onChange(e))} disabled={disabledInput} required />
                                {information.registered_mail.error !== "" ?
                                    <div className="invalid-tooltip">{information.registered_mail.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaEnvelope /></label>
                                <input type="email" className="form-control" placeholder="Confirmez votre Email *" name={"confirmEmail"} value={information.confirmEmail.value} onChange={e => dispatch(onChange(e))} disabled={disabledInput} required />
                                {information.confirmEmail.error !== "" ?
                                    <div className="invalid-tooltip">{information.confirmEmail.error}</div>
                                    : ""}
                            </div>
                            <div className={"col-12 col-md-6 input-group"}>
                                <label><FaPhone /></label>
                                <PhoneInput value={information.registered_phone.value} onChange={e => dispatch(onChange(e))} />
                                {information.registered_phone.error !== "" ?
                                    <div className="invalid-tooltip">{information.registered_phone.error}</div>
                                    : ""}
                            </div>
                            {user === null ?
                                <>
                                    <div className={"col-12 input-group"}>
                                        <p className={"important-infos col-12 text-center mb-1"}>Merci de sélectionner votre type d'inscription</p>
                                    </div>
                                    <ProfessionalInput value={information.professionalCtgSelect.value}
                                        onChange={e => dispatch(onChange(e))}
                                        valueTextInput={information.registered_profession_category.value}
                                        error={information.professionalCtgSelect.error}
                                        disabled={disabledInput} />
                                </> : ""}
                        </div>
                    </div>



                    <div className={"content-footer"}>
                        <a className={"sr-btn-next btn btn-secondary"} href={"https://cfp2022.urevent.fr"}>Accueil</a>
                        <small className={"help"}><HelpUr /></small>
                        <button type={"submit"} name={"myButton"} value={"Suivant"} className={"sr-btn-next btn btn-info"}>Suivant</button>
                    </div>
                </form>
            </div>
        )
    } else {
        return (
            <div className={"content about"}>
                <p className={"title"} dangerouslySetInnerHTML={{ __html: txt_accueil }}></p>
                <p className={"important-infos"} dangerouslySetInnerHTML={{ __html: txt_accueil2 }}></p>
            </div>
        )
    }
}

About.propTypes = {
    prevTab: PropTypes.func.isRequired,
    nextTab: PropTypes.func.isRequired,
}

export default About
